
import './App.css';
import LoginSingup from './desktop/loginSingup';
import './assets/themeColor.css'
import ThemeContextProvider from './context/themeContext';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dashbord from './desktop/main';
import UserContextProvider from './context/userContext';
import LoginSingupPageContextProvider from './context/loginSingupPageContext';
import NavIconContextProvider from './context/NavIconContext'
import React from 'react'

function App() {



  return (
    <div className="light">
       <BrowserRouter>
      <ThemeContextProvider>
        <UserContextProvider>
          <NavIconContextProvider>

         
       
        <ToastContainer/>
     <Switch>  
           
            <Route exact path="/">
            <Dashbord/> 
            </Route>
           <LoginSingupPageContextProvider>
            <Route component={LoginSingup}  path="/account" />
            <Route path="" > <Dashbord/></Route>
           
            </LoginSingupPageContextProvider>
      
      
      
      </Switch>
      </NavIconContextProvider>
      </UserContextProvider>
      </ThemeContextProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
